import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { signIn } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { Button, InputGroup, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../../components/Modals/CustomModal';
import { IoEye, IoEyeOff } from "react-icons/io5";

// Cognito username = email
type SignInData = {
  username: string;
  password: string;
};

const SignInScreen = () => {
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  // VALIDATION
  const [passwordHidden, setPaswordHidden] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {register, control, handleSubmit, watch, reset} = useForm<SignInData>();

  useEffect(() => {
    document.title = t('title.signin');
  }, []);

  const onSignInPressed = async ({username, password}: SignInData) => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      const { isSignedIn, nextStep } = await signIn({username, password});
      // if (nextStep.signInStep == 'CONFIRM_SIGN_UP') {
      //   navigate(t('link.dashboard'));
      // }
      navigate(t('link.dashboard'), { state: { status: "bg-dark", title: "", toastMessage: t('toast.welcome'), toastUsername: true}});
    } catch (error) {
        console.log('error signing in: ', error);
        setContentModal(<><Modal.Header closeButton>
          <Modal.Title>{t('signup.error')}</Modal.Title>
              </Modal.Header>
        
              <Modal.Body>
                <p>{(error as Error).message}.</p>
              </Modal.Body></>);
        setShowCustomModal(true);
    } finally {
      setLoading(false);
      reset();
    };
  };

  const goToForgotPassword = () => {
    navigate('/forgotPassword');
  };

  const goToRegister = () => {
    navigate('/signup');
  };

  return (
    <>
      <CustomModal
          show={showCustomModal}
          onHide={() => setShowCustomModal(false)}
          link={linkModal}
          children={contentModal}
          // animation={true}
        />
      <Form className="register-form ms-2 me-2 flex-wrap ">
        <h2 className="text-center">{t('signup.login_form')}</h2>
            <InputGroup style={{marginTop: 10, marginBottom: 10}}>
              {/* <InputGroup.Text id="basic-addon1">@</InputGroup.Text> */}
              <Form.Control
                placeholder={t('navBar.email')}
                aria-label="Username"
                aria-describedby="basic-addon1"
                className="d-inline me-lg-2"
                {...register("username")} 
                name="username"
              />
            </InputGroup>
            <InputGroup style={{marginTop: 10, marginBottom: 10}}>
              <Form.Control
                type={passwordHidden ? "password" : "text"}
                placeholder={t('navBar.password')}
                className="me-lg-2" 
                {...register("password")} 
                name="password"
              />
              { passwordHidden ?
                <IoEye onClick={() => setPaswordHidden(false)} name="eye" size={30} color="#000" style={{position: 'absolute', right: 15, top: 5}}/>
              : 
                <IoEyeOff onClick={() => setPaswordHidden(true)} name="eye-slash" size={30} color="#000" style={{position: 'absolute', right: 15, top: 5}} />
              }
            </InputGroup>
            <InputGroup style={{marginTop: 10, marginBottom: 10}}>
              <Button type="submit" onClick={handleSubmit(onSignInPressed)}>{t('navBar.login')}</Button>
            </InputGroup>
            <InputGroup style={{marginTop: 10, marginBottom: 10}}>
              <Button type="button" onClick={goToRegister}>{t('navBar.signup')}</Button>
            </InputGroup>
            <InputGroup style={{marginTop: 10, marginBottom: 10}}>
              <Button type="button" onClick={goToForgotPassword}>{t('signup.goToForgotPassword')}</Button>
            </InputGroup>
      </Form>
    </> 
  );
};

export default SignInScreen;
